import React from 'react';
import { TableCell, TableRow } from '@storebrand-digital/pretzel';
import { SkeletonBox } from '../../components/Skeleton/SkeletonBox';
import styles from './Document.Table.SkeletonRow.module.css';

function DocumentTableSkeletonRow() {
  return (
    <TableRow>
      <TableCell className="document-name">
        <div className={styles.skeletonContainer}>
          <SkeletonBox width="150px" height="15px" />
          <SkeletonBox width="108px" height="9px" />
        </div>
      </TableCell>
      <TableCell className="document-contract-number" align="left">
        <SkeletonBox width="87px" height="13px" />
      </TableCell>
      <TableCell className="document-date" align="right">
        <SkeletonBox width="88px" height="13px" />
      </TableCell>
    </TableRow>
  );
}

export default DocumentTableSkeletonRow;
